/**
 * **SimpleBooking**
 *
 *
 *
 * @exports partnership_170
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
    * @memberOf module:partnership_170
    */
    partnership.getId = function getId() {
        return '170';
    };
    /**
    * @memberOf module:partnership_170
    */
    partnership.check = function check() {
        return window.location.hostname.includes('simplebooking');
    };
    /**
    * @memberOf module:partnership_170
    */
    partnership.getSiteId = function getSiteId() {
        const hotelId = thn.parseUrlParameter('hid') || window.location.pathname.match(/hotel\/(\d+)\/*/)[1];
        const result = {
            externalId: hotelId,
        };
        return result;
    };
    return partnership;
}

export { factory };
